import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import format from 'date-fns/format'
import koLocale from 'date-fns/locale/ko'
import './index.css'

class ChatList extends Component {
  componentDidMount() {
    if (this.props.chats.length) {
      return
    }

    this.props.onLoad()
  }

  formatDate(isoString) {
    return format(new Date(isoString), 'yyyy년 M월 dd일 HH시 mm분 ss초', { locale: koLocale })
  }

  render() {
    if (this.props.isLoading) {
      return <div>Loading...</div>
    }

    return (
      <ul className="chat-list" style={{ listStyle: 'none' }}>
        {
          this.props.chats.map(chat => (
            <li key={chat.id} style={{ margin: '20px' }}>
              <Link to={`/chats/${chat.id}`}>
                <span>{chat.partner.name}</span>:
                <span>{chat.lastMessage.text}</span> |
                <span style={{ color: 'gray' }}>({this.formatDate(chat.lastMessage.created_at)})</span>
              </Link>
            </li>
          ))
        }
      </ul>
    )
  }
}

export default ChatList
